import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceAIValueLoop from '../components/services/ServiceAIValueLoop'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { DATA_AI_CAPABILITIES_PT } from '../constants/serviceCapabilitiesDataAi'
import { SERVICE_ONE_TEAM_APPLICATION_PT } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsPt } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'

const DadosIaPagePt = () => (
  <Layout lang="pt" title="Dados & IA" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Serviços"
        title={'Dados & IA.'}
        description={
          'Transformamos dados complexos em soluções inteligentes e acionáveis, com infraestrutura escalável e capacidades potenciadas por IA.'
        }
        heroImage={SERVICE_HERO_ASSETS.data.src}
        imageAlt="Ilustração de dados e IA"
        imageWidth={SERVICE_HERO_ASSETS.data.width}
        imageHeight={SERVICE_HERO_ASSETS.data.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.data.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.data.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-data-ai"
        sectionTitle="Capacidades que potenciam Dados & IA."
        tabs={DATA_AI_CAPABILITIES_PT}
        contactCtaIsEn={false}
      />
      <ServiceAIValueLoop lang="pt" />
      <HomeTwo lang="pt" />
      <ServiceOneTeam
        idBase="service-one-team-data-ai"
        {...SERVICE_ONE_TEAM_APPLICATION_PT}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-data-ai"
        {...createServiceOtherSolutionsPt('data-ai')}
      />
    </div>
  </Layout>
)

export default DadosIaPagePt
